import { render, staticRenderFns } from "./signin.vue?vue&type=template&id=1422e420&scoped=true&"
import script from "./signin.vue?vue&type=script&lang=js&"
export * from "./signin.vue?vue&type=script&lang=js&"
import style0 from "./signin.vue?vue&type=style&index=0&id=1422e420&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422e420",
  null
  
)

export default component.exports